import DynamicForm from "components/DynamicForm";
import { Fragment, useEffect } from "react";
import "./index.scss";
import Label from "lib/Label";
import { useSelector, useDispatch } from "react-redux";
import FormButton from "components/FormButton";
import {
  setAddSavedFormFields,
  setAddSaveData,
  setRecursiveFormData,
  setDeleteSaveData,
  setDeleteFormFields,
  setEditIndex,
  setFieldRecursiveName,
  clearFieldRecursionData,
} from "redux/fieldRecursiveReducer";

const FieldRecursive = (props) => {
  const {
    setSelectedData,
    selectedData,
    inputFields,
    recursiveActions,
    recursiveTitle,
    formErr,
    clearFieldError,
    minLength,
    maxLength,
  } = props;
  const inputField = inputFields[0];
  const formData = useSelector((state) => state.formData);
  const formField = useSelector(
    (state) => state?.fieldRecursiveReducer?.savedFormFields
  );
  const editIndex = useSelector(
    (state) => state?.fieldRecursiveReducer?.editIndex
  );
  const dispatch = useDispatch();
  const selectedFormData = useSelector((state) => state.formData?.selectedData);

  useEffect(() => {
    dispatch(clearFieldRecursionData());
    if (formData?.selectedData[recursiveTitle]) {
      let recursiveObj = { ...formData?.selectedData[recursiveTitle] };
      if (formData?.selectedData[recursiveTitle]?.length === 0) {
        dispatch(
          setAddSavedFormFields({
            ...inputField,
            id: inputField.id + `_${formField.length}`,
            name: inputField.name + `_${formField.length}`,
            value: {}, // default value
            index: 0,
          })
        );
        dispatch(
          setAddSaveData({
            id: inputField.id + `_${formField.length}`,
            name: inputField.name + `_${formField.length}`,
            value: {}, // default value
          })
        );
        dispatch(setEditIndex(0));
      }
      Object.keys(recursiveObj).map((_item) => {
        let item = recursiveObj[_item];
        dispatch(
          setAddSavedFormFields({
            ...inputField,
            id: item.id,
            name: item.name,
            value: item.value,
          })
        );
        dispatch(
          setAddSaveData({
            id: item.id,
            name: item.name,
            value: item.value,
          })
        );
      });
      
    } else {
      dispatch(
        setAddSavedFormFields({
          ...inputField,
          id: inputField.id + `_${formField.length}`,
          name: inputField.name + `_${formField.length}`,
          value: {}, // default value
          index: 0,
        })
      );
      dispatch(
        setAddSaveData({
          id: inputField.id + `_${formField.length}`,
          name: inputField.name + `_${formField.length}`,
          value: {}, // default value
        })
      );
      dispatch(setEditIndex(0));
    }
    dispatch(setFieldRecursiveName(recursiveTitle));
  }, []);

  const handleAddMore = async () => {
    dispatch(
      setAddSaveData({
        id: inputField.id + `_${formField.length}`,
        name: inputField.name + `_${formField.length}`,
        value: {}, // giving default values
      })
    );
    dispatch(
      setAddSavedFormFields({
        ...inputField,
        id: inputField.id + `_${formField.length}`,
        name: inputField.name + `_${formField.length}`,
        value: {},
      }) //? Add recursiveFormData here?
    );
  };

  const handleDelete = (e, index) => {
    dispatch(setDeleteFormFields(index));
    dispatch(setDeleteSaveData(index));
  };

  const handleOnFocus = (index) => {
    dispatch(setEditIndex(index));
  };

  return (
    <>
      <Label label={`${inputField?.label}`} />

      {formField &&
        formField?.map((item, index) => {
          //Showing the already filled data values
          return (
            <div
              onFocus={() => handleOnFocus(index)}
              key={index}
              style={{
                // width: "90%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-evenly",
              }}
            >
              <DynamicForm
                formErr={formErr}
                clearFieldError={clearFieldError}
                setSelectedData={setRecursiveFormData}
                selectedData={
                  item.type === "upload" ? selectedFormData : formField[index]
                }
                formButtons={recursiveActions}
                recursiveFormButtons={recursiveActions}
                formFields={item}
              />
              <button
                onClick={(e) => handleDelete(e, index)}
                type="button"
                class="btn-close"
                aria-label="Close"
                style={{ margin: "5px", padding: "5px" }}
              ></button>
            </div>
          );
        })}
      <FormButton
        formButtons={recursiveActions}
        handleFieldAddMore={handleAddMore}
        className="field_button"
      />
    </>
  );
};
export default FieldRecursive;
